import { Inertia } from '@inertiajs/inertia';
import cookies from '@/helpers/cookies';
import rescue from '@/helpers/rescue';
import route from '@/helpers/route';
import value from '@/helpers/value';

const Facebook = new Promise(resolve => {
  window.addEventListener('DOMContentLoaded', () => resolve());
});

const events = {
  'coupons.index': [
    'ViewContent',
  ],
  'coupons.show': ({ coupon }) => [
    'ViewContent',
    { content_name: coupon.name },
  ],
  'thanks': ({ total }) => [
    'Purchase',
    { currency: 'EUR', value: total },
  ],
}

Inertia.on('navigate', event => {
  if (cookies.get('FEATURE-FACEBOOK') !== 'true')
    return;

  try {
    Object.keys(events).some(key => {
      if (route().current(key)) {
        track(...value(events[key], event.detail.page.props));
        return true;
      }
    });
  } catch (error) {
    //
  }
});

Inertia.on('start', event => {
  if (cookies.get('FEATURE-FACEBOOK') !== 'true')
    return;

  const element = event.target.activeElement;

  try {
    if (!('fbTrack' in element.dataset))
      return;

    track(
      element.dataset.fbTrack,
      rescue(() => JSON.parse(element.dataset.fbData), {})
    );
  } catch (error) {
    //
  }
});

Facebook.then(() => {
  if (cookies.get('FEATURE-FACEBOOK') !== 'true')
    fbq('consent', 'revoke');
  else
    fbq('consent', 'grant')

  fbq('init', '865850154356085');
});

export function grant() {
  Facebook.then(() => fbq('consent', 'grant'));
}

export function revoke() {
  Facebook.then(() => fbq('consent', 'revoke'));
}

export function track(event, payload = {}) {
  Facebook.then(() => fbq('track', event, payload));
}

export function enable() {
  cookies.set('FEATURE-FACEBOOK', 'true', { sameSite: 'lax', expires: 365 });
  grant();
}

export function disable() {
  cookies.set('FEATURE-FACEBOOK', 'false', { sameSite: 'lax', expires: 365 });
  revoke();
}

export function set(value) {
  value ? enable() : disable();
}
